import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { Bau365UtilKeycloakModule } from '@planone/bau365/util-keycloak';
import { Bau365UtilUserDataModule } from '@planone/bau365/util-user-data';
import { SharedDataAccessCountriesModule } from '@planone/shared/data-access-countries';

import { SharedUtilDownloadsModule } from '@planone/shared/util-downloads';

import { Bau365DataAccessUserTrackingModule } from './bau365-data-access-user-tracking.module';
import { WatchlistResolver } from './resolver/watchlist.resolver';
import { ChannelsService } from './service/channels/channels.service';
import { UserHistoryService } from './service/history/history.service';
import { UserService } from './service/user/user.service';
import { WatchlistService } from './service/watchlist/watchlist.service';
import { NewsfeedChannelsEffects } from './state/channels/channels.effects';
import { NewsfeedChannelsFacade } from './state/channels/channels.facade';
import * as fromNewsfeedChannels from './state/channels/channels.reducer';
import { EnrichedWatchlistEffects } from './state/enriched-watchlist/enriched-watchlist.effects';
import { EnrichedWatchlistFacade } from './state/enriched-watchlist/enriched-watchlist.facade';
import * as fromEnrichedWatchlist from './state/enriched-watchlist/enriched-watchlist.reducer';
import { UserHistoryEffects } from './state/history/history.effects';
import { UserHistoryFacade } from './state/history/history.facade';
import * as fromUserHistory from './state/history/history.reducer';
import { DataAccessUserPageFacade } from './state/page/data-access-user.page.facade';
import { DataAccessUserEffects } from './state/user/data-access-user.effects';
import { DataAccessUserFacade } from './state/user/data-access-user.facade';
import * as fromDataAccessUser from './state/user/data-access-user.reducer';
import { WatchlistEffects } from './state/watchlist/watchlist.effects';
import { WatchlistFacade } from './state/watchlist/watchlist.facade';
import * as fromWatchlist from './state/watchlist/watchlist.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromDataAccessUser.DATA_ACCESS_USER_FEATURE_KEY, fromDataAccessUser.reducer),
    StoreModule.forFeature(fromWatchlist.WATCHLIST_FEATURE_KEY, fromWatchlist.watchlistReducer),
    StoreModule.forFeature(
      fromNewsfeedChannels.NEWSFEED_CHANNELS_FEATURE_KEY,
      fromNewsfeedChannels.newsfeedChannelsReducer
    ),
    StoreModule.forFeature(
      fromEnrichedWatchlist.ENRICHED_WATCHLIST_FEATURE_KEY,
      fromEnrichedWatchlist.enrichedWatchlistReducer
    ),
    StoreModule.forFeature(fromUserHistory.USER_HISTORY_FEATURE_KEY, fromUserHistory.userHistoryReducer),
    EffectsModule.forFeature([
      DataAccessUserEffects,
      WatchlistEffects,
      EnrichedWatchlistEffects,
      NewsfeedChannelsEffects,
      UserHistoryEffects,
    ]),
    Bau365DataAccessUserTrackingModule,
    SharedDataAccessCountriesModule,
    SharedUtilDownloadsModule,
    Bau365UtilUserDataModule,
    Bau365UtilKeycloakModule,
  ],
  providers: [
    DataAccessUserFacade,
    DataAccessUserPageFacade,
    NewsfeedChannelsFacade,
    EnrichedWatchlistFacade,
    UserHistoryFacade,
    UserService,
    ChannelsService,
    WatchlistService,
    UserHistoryService,
    WatchlistFacade,
    WatchlistResolver,
  ],
})
export class Bau365DataAccessUserModule {}
